module.exports = __webpack_public_path__ + "img/59.a56b5aff.jpg";